<template>
    <div>
        <ui-select
            :label="label"
            :keys="{ label:'display_name', value: 'id' }"
            has-search
            :options="options"
            :disabled="isLoading || disabled"
            v-model="selected"
            @change="handleChange"
            :placeholder="isLoading ? 'Loading teams...' : 'Select team'"
        ></ui-select>
    </div>
</template>

<script>
    import useAuthorisedTeams from "../../../../ts/stores/team-store";

    export default {
        props: {
            label: {
                type: String,
            },
            value: {
                type: Object,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            onlyBookable: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    this.selected = newVal;
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
                options: [],
                isLoading: true,
            }
        },
        mounted() {
            const { authorizedBookableTeams, authorizedTeams, isLoading } = useAuthorisedTeams();

            this.isLoading = isLoading;

            this.selected = this.value;

            this.options = authorizedTeams

            if (this.onlyBookable) {
                this.options = authorizedBookableTeams
            }
        },
        methods: {
            handleChange(e) {
                this.$emit('input', e);
            }
        }
    }
</script>